module.exports = __webpack_public_path__ + "img/breathe.33e21156.svg";